import React, { useState } from 'react';

export default function AgentDeployModal({ agent, onClose }) {
  const [tab, setTab] = useState('api'); // 'api' or 'widget'

  if (!agent) return null;

  return (
    <div className="lb-modal-overlay" onClick={onClose}>
      <div className="lb-modal lb-deploy-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Deploy {agent.name}</h2>

        {/* === tab buttons === */}
        <div className="lb-tabs">
          <button
            className={`lb-tab ${tab === 'api' ? 'active' : ''}`}
            onClick={() => setTab('api')}
          >
            🔌 API
          </button>
          <button
            className={`lb-tab ${tab === 'widget' ? 'active' : ''}`}
            onClick={() => setTab('widget')}
          >
            🧩 Widget
          </button>
        </div>

        {/* === API content === */}
        {tab === 'api' && (
          <>
            <p className="lb-subhead">Call this agent via REST API:</p>
            <pre className="lb-codeblock">{`POST https://api.lextrack.ai/agents/${agent.id}
Authorization: Bearer <YOUR_TOKEN>
Content-Type: application/json

{
  "name": "John",
  "goals": "Summarize inbox",
  "email": "john@example.com"
}`}</pre>
            <p className="lb-note">🔑 Generate API keys under Settings ▸ API Keys</p>
          </>
        )}

        {/* === Widget content === */}
        {tab === 'widget' && (
          <>
            <p className="lb-subhead">Embed this agent as a widget:</p>
            <pre className="lb-codeblock">{`<script src="https://cdn.lextrack.ai/widget.js" defer></script>
<div id="lex-agent" data-agent="${agent.id}"></div>`}</pre>
            <p className="lb-note">
              Customize style via CSS vars: <code>--lex-primary</code>, <code>--lex-radius</code>, etc.
            </p>
          </>
        )}

        {/* === footer === */}
        <div className="lb-form-footer">
          <button className="lb-secondary-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
